/**
 * Navigation Dimensions Constants
 *
 * Centralized dimension values for consistent layout.
 * These should be used instead of hardcoded values throughout the module.
 */

/** Standard sidebar width when expanded */
export const DRAWER_WIDTH = 250;

/** Sidebar width when collapsed */
export const COLLAPSED_DRAWER_WIDTH = 60;

/** Right sidebar width */
export const RIGHT_SIDEBAR_WIDTH = 56;

/** Mobile breakpoint key for MUI theme */
export const MOBILE_BREAKPOINT = 'md' as const;

/** Minimum touch target size for accessibility */
export const MIN_TOUCH_TARGET = 44;

/** Standard icon size in menu items */
export const MENU_ICON_SIZE = 24;

/** Spacing between menu items */
export const MENU_ITEM_SPACING = 8;

/** Menu item height */
export const MENU_ITEM_HEIGHT = 48;

/** Project selector height (aligned with product tabs toolbar) */
export const PROJECT_SELECTOR_HEIGHT = 48;

/** Transition duration for animations (ms) */
export const TRANSITION_DURATION = 225;

/** Z-index values */
export const Z_INDEX = {
  /** Sidebar drawer */
  sidebar: 1200,
  /** Right sidebar */
  rightSidebar: 1100,
  /** Mobile overlay */
  overlay: 1199,
  /** Dropdown menus */
  dropdown: 1300,
} as const;

/**
 * Get drawer width based on collapsed state
 */
export function getDrawerWidth(collapsed: boolean): number {
  return collapsed ? COLLAPSED_DRAWER_WIDTH : DRAWER_WIDTH;
}
